import script from "./CreatorLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatorLayout.vue?vue&type=script&setup=true&lang=js"

import "./CreatorLayout.vue?vue&type=style&index=0&id=686867de&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-686867de"]])

export default __exports__